
export const jobsCreationPath = (id?: string | number) =>
    id ? `/jobs-add/${id}` : `/jobs-add`;